import * as React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as ReportModule from 'Modules/ReportModule';
import i18next from 'i18next';
import {Cell, injectThProps} from 'HelperFunctions/Lists';
import {InfinityReactTable, InfinityScrollParams} from 'components/common/InfinityReactTable';
import {DEFAULT_PAGE_SIZE} from '../../../constants'
import {VehicleStateReportParam} from 'Models/ReportModel'

type P = {
    //
} & DispatchedP & ConnectedP;
type S = {
    //
};
type DispatchedP = {
  getVehiclesStateReport: (params: VehicleStateReportParam) => Promise<void>
}
type ConnectedP = {
    reportStore: ReportModule.Types.ReportStore;
    t?: i18next.TFunction;
};
const tmpInlineStyle: any = {
    height: '70vh',
    overflowY: 'scroll'
};

class TerminalInstallationReport extends React.Component<P, S> {
  constructor(props: P) {
    super(props)

    this.infinityScrollParams = new InfinityScrollParams(35);
    this.infinityScrollParams.setWaypointRef(React.createRef());
    this.onFetchData = this.onFetchData.bind(this);
  }
  private infinityScrollParams: InfinityScrollParams;

  private getTrProps = (state, rowInfo, column) => {
    return { };
  }

  private onFetchData = (tableState: any, scrolled: boolean = false, loadedCount: number = null) => {
    const { vehiclesStateReportLatestUrlParams, vehiclesStateReport } = this.props.reportStore
    if (!scrolled) {
      return
    }

    const latestFirst = vehiclesStateReportLatestUrlParams.first ?? 0
    const first = scrolled ? latestFirst + DEFAULT_PAGE_SIZE : latestFirst

    //ToDo: uogólnić do utila
    if (
      vehiclesStateReport.vehiclesState.totalCount !== null
      && (vehiclesStateReport.vehiclesState.totalCount <= first
      || vehiclesStateReport.vehiclesState.totalCount <= latestFirst)
    ) {
      return
    }

    this.props.getVehiclesStateReport({
      ...vehiclesStateReportLatestUrlParams,
      first
    })

  }

  public render() {
        const {
          reportStore: {
            vehiclesStateReport,
            allVehiclesStateReports
          },
          t
        } = this.props;

        let pageSize = DEFAULT_PAGE_SIZE
          if (vehiclesStateReport) {
            pageSize = Number(vehiclesStateReport.vehiclesState.results.length < vehiclesStateReport.vehiclesState.max
              ? vehiclesStateReport.vehiclesState.results.length
              : vehiclesStateReport.vehiclesState.max)
          }


        if (vehiclesStateReport) {
            return (
              <>
                <h3 className="main__title">{t('Raport stanu pojazdów')}</h3>
                <span>{vehiclesStateReport.reportTitle}</span>
                <div className="table-vehicle-state-report" style={tmpInlineStyle}
                     ref={this.infinityScrollParams.getWaypointRef()}>
                  <InfinityReactTable
                    data={allVehiclesStateReports}
                    dataLength={vehiclesStateReport.vehiclesState.totalCount}
                    filterable={false}
                    resizable
                    columns={this.renderColumns(t)}
                    waypointRef={this.infinityScrollParams.getWaypointRef()}
                    manual={true}
                    getTrProps={this.getTrProps}
                    getTheadThProps={injectThProps}
                    onFetchData={this.onFetchData}
                    pageSize={pageSize}
                    loadingText={t(`tables:${'loading'}`)}
                    pageText={t(`tables:${'pageText'}`)}
                    nextText={t(`tables:${'nextText'}`)}
                    previousText={t(`tables:${'previousText'}`)}
                    rowsText={t(`tables:${'rowsText'}`)}
                    noDataText={t(`tables:${'noDataText'}`)}
                  />
                </div>
                <div className="table__footer">
                  <div>
                    {allVehiclesStateReports.length} z {vehiclesStateReport.vehiclesState.totalCount}
                  </div>
                  {this.infinityScrollParams.getIsLoading() && <div className="table__footer-loader"/>}
                </div>
              </>
            );
        } else {
          return null;
        }
  }

  private renderColumns = (t) => [
    {
      Header: Cell.HeaderTextCell(t('orderNumber')),
      accessor: 'orderNumber',
      Cell: Cell.CutTextCell
    },
    {
      Header: Cell.HeaderTextCell(t('sellerProposalNumber')),
            accessor: 'sellerProposalNumber',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('deviceId')),
            accessor: 'deviceId',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell('VIN'),
            accessor: 'vin',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('carModel')),
            accessor: 'model',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('mileage')),
            accessor: 'mileage',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('carCreationDate')),
            accessor: 'carCreationDate',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('receiveDate')),
            accessor: 'lastFrameDate',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('numberOfReceivedFrames')),
            accessor: 'numberOfReceivedFrames',
            Cell: Cell.CutTextCell
        }
    ];
}

function mapDispachToProps(dispatch: any): DispatchedP {
  return {
    getVehiclesStateReport: (params) => dispatch(ReportModule.Actions.getVehiclesStateReport(params)),
  };
}

function mapStateToProps(state: any): ConnectedP {
    return {
        reportStore: state.reportStore
    };
}

export default withTranslation('reports')(connect(mapStateToProps, mapDispachToProps)(TerminalInstallationReport) as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/ReportsComposites/VehiclesStateReportPresent.tsx